import { geocodeByAddress } from "react-places-autocomplete";

export const isGoogleMapsLoaded = () => {
    return !!window.google?.maps?.Geocoder;
};

export const waitForGoogleMaps = async (
  timeout = 3000
): Promise<void> => {
  const start = Date.now();

  while (Date.now() - start < timeout) {
    if (window.google?.maps?.Geocoder) {
      return;
    }

    await new Promise(resolve => setTimeout(resolve, 100));
  }

  throw new Error("API do Google Maps não foi carregada.");
};

export const safeGeocodeByAddress = async (address: string) => {
  await waitForGoogleMaps();

  return geocodeByAddress(address);
};